const initialState = {
    value: false
}

export const validateProgramParticipants = (state = initialState, actions) => {
    if (actions.type === 'SET_VALIDATE') {
        return {
            ...state,
            value: actions.value
        }
    }
    return state
}